/** Partition step questions into LITE (already answered) vs remaining (full only). */
export function partitionStepQuestions(questions, liteQuestionIds) {
  const liteSet = new Set(liteQuestionIds || []);
  const liteQuestions = [];
  const remainingQuestions = [];
  for (const q of questions || []) {
    if (liteSet.has(q.id)) {
      liteQuestions.push(q);
    } else {
      remainingQuestions.push(q);
    }
  }
  return { liteQuestions, remainingQuestions };
}

export function isLiteQuestion(questionId, liteQuestionIds) {
  return new Set(liteQuestionIds || []).has(questionId);
}
